var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 203.246,
    height: 60.433,
    viewBox: "0 0 203.246 60.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0-18.973H203.246V-79.406H0Z",
    transform: "translate(0 79.406)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 79.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 -79.406)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-33.413-9.487A30.216,30.216,0,0,0-62.906-39.694V-39.7h-46.717A30.217,30.217,0,0,0-139.84-9.487,30.217,30.217,0,0,0-109.623,20.73h46.717v-.009A30.216,30.216,0,0,0-33.413-9.487",
    transform: "translate(139.84 39.703)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(13.992 8.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-7.077-3.14A23.138,23.138,0,0,1-4.3-.134L-5.938,1.021a.265.265,0,0,0,.174.481H5.548L5.541-9.007a.278.278,0,0,0-.29-.269.289.289,0,0,0-.228.107L3.944-7.848c-2.833-2.815-7.636-5.3-14.543-5.3-8.447,0-15.44,3.9-19.018,10.321a15.861,15.861,0,0,1,11.36-4.741A16.217,16.217,0,0,1-7.077-3.14",
    transform: "translate(29.617 13.143)",
    fill: "#99c93d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(11.413 8.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-21.961-9.7a16.382,16.382,0,0,1-5.031.847c-5.632,0-9.022-3.063-9.953-6.549a.385.385,0,0,1,.373-.483L-8.915-15.9l0-2.7c-.005-13.417-8.517-22-20.216-22a20.7,20.7,0,0,0-17.149,8.433c-13.042,16.822-15.4,22.173-23.456,21.9-5.233-.177-9.244-3.681-9.244-9.653s4.008-9.572,9.244-9.572a10.481,10.481,0,0,1,1.776.15h0l-.014-.014A14.49,14.49,0,0,0-77.97-33.3,13.74,13.74,0,0,0-91.9-20.415c0,.166-.006.332-.006.5,0,12.435,9.245,20.779,21.6,20.779,8.261,0,14.367-4.155,19.209-9.28,0,0,2.162-2.438,2.168-2.446a.384.384,0,0,1,.642.081A11.713,11.713,0,0,0-47-8.495c3.756,4.575,9.919,5.063,11.126,5.151C-29.691-2.9-24.2-5.581-21.961-9.7M-37.132-24.532a7.754,7.754,0,0,1,8-6.327c5.5,0,7.63,3.594,8.117,6.337a.384.384,0,0,1-.38.449l-15.364.007a.385.385,0,0,1-.377-.467",
    transform: "translate(91.908 40.594)",
    fill: "#72cce0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(62.501 37.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-6.249,0A.236.236,0,0,0-6.4.427l1.45,1.021c-1.879,5.678-8.681,9.618-16.379,9.061a28.554,28.554,0,0,1-4.822-.738A23.459,23.459,0,0,0-13.877,13.01c5.846,0,12.148-1.607,16.108-4.886l1.1,1.354a.258.258,0,0,0,.2.094A.249.249,0,0,0,3.8,9.334L3.8,0-6.248,0Z",
    transform: "translate(26.154 0.003)",
    fill: "#99c93d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(115.012 6.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0-3.255A10.3,10.3,0,0,1,10.194-13.624a9.971,9.971,0,0,1,8.184,4.165L15.291-7.217A5.894,5.894,0,0,0,10.34-9.809,6.343,6.343,0,0,0,4.049-3.255,6.345,6.345,0,0,0,10.31,3.327,5.909,5.909,0,0,0,15.291.735l3.087,2.243a9.972,9.972,0,0,1-8.184,4.165A10.287,10.287,0,0,1,0-3.255",
    transform: "translate(0 13.624)",
    fill: "#076d38"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M177.413-71.489h3.816v21h-3.816Z",
    transform: "translate(-42.391 -1.892)",
    fill: "#076d38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 -79.406)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(140.821 13.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-4.462-2.634H-14.686A3.329,3.329,0,0,0-11.19-.1,4.857,4.857,0,0,0-7.608-1.7L-5.395.542a7.6,7.6,0,0,1-6.029,2.738,6.93,6.93,0,0,1-7.252-7.136,6.992,6.992,0,0,1,7.223-7.165A6.8,6.8,0,0,1-4.375-4.09c0,.378-.03.844-.088,1.456M-8.22-5.109A2.9,2.9,0,0,0-11.365-7.73a3.161,3.161,0,0,0-3.321,2.621Z",
    transform: "translate(18.676 11.022)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(156.174 13.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-3.466-.11H.35v13.6H-3.466V11.541a5.385,5.385,0,0,1-4.486,2.3c-3.757,0-6.553-2.913-6.553-7.136s2.738-7.165,6.64-7.165A5.218,5.218,0,0,1-3.466,1.7Zm-.116,6.815A3.58,3.58,0,0,0-7.135,3.094,3.507,3.507,0,0,0-10.6,6.706a3.541,3.541,0,0,0,3.495,3.582A3.587,3.587,0,0,0-3.582,6.706",
    transform: "translate(14.504 0.459)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(173.213 13.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-4.17-2.039V5.417H-7.985V-1.835c0-2.126-1.282-3.088-2.592-3.088a2.9,2.9,0,0,0-3.059,3.2V5.417h-3.815v-13.6h3.815v2.3c.583-1.835,2.738-2.65,4.078-2.65C-6-8.534-4.141-6.117-4.17-2.039",
    transform: "translate(17.451 8.534)",
    fill: "#076d38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(116.273 -49.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-1.271-5.176h8.8v3.582H-5.319V-21.661H7.263v3.583H-1.271V-13.3H6.214v3.64H-1.271Z",
    transform: "translate(5.319 21.661)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 -79.406)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(131.303 36.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-4.17-2.039V5.417H-7.985V-1.835c0-2.126-1.282-3.088-2.592-3.088a2.9,2.9,0,0,0-3.059,3.2V5.417h-3.815v-13.6h3.815v2.3c.583-1.835,2.738-2.65,4.078-2.65C-6-8.534-4.141-6.117-4.17-2.039",
    transform: "translate(17.451 8.534)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(146.455 36.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-4.462-2.634H-14.686A3.329,3.329,0,0,0-11.19-.1,4.859,4.859,0,0,0-7.608-1.7L-5.395.541a7.6,7.6,0,0,1-6.029,2.738,6.93,6.93,0,0,1-7.252-7.136,6.992,6.992,0,0,1,7.223-7.165A6.8,6.8,0,0,1-4.375-4.09c0,.379-.03.845-.088,1.457M-8.22-5.109A2.9,2.9,0,0,0-11.365-7.73a3.162,3.162,0,0,0-3.321,2.621Z",
    transform: "translate(18.676 11.022)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(162.653 36.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-3.118-.137-3.992,3.5a3.953,3.953,0,0,0-1.951-.5c-1.951,0-3.291,1.835-3.291,5.709v4.66H-13.05V-.225h3.786V2.688c.757-2.272,2.3-3.262,3.99-3.262a4.843,4.843,0,0,1,2.155.437",
    transform: "translate(13.05 0.574)",
    fill: "#076d38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(172.724 36.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-3.466-.11H.35V11.8c0,5.942-3,8.709-7.805,8.709a7.192,7.192,0,0,1-6.611-4.165l3.174-1.368A3.856,3.856,0,0,0-7.456,17.1c2.446,0,3.99-1.368,3.99-4.893v-.379a5.633,5.633,0,0,1-4.368,2.01A6.793,6.793,0,0,1-14.5,6.677,6.766,6.766,0,0,1-7.834-.459a5.566,5.566,0,0,1,4.368,1.98Zm-.116,6.786A3.585,3.585,0,0,0-7.106,3.094a3.549,3.549,0,0,0-3.524,3.582,3.593,3.593,0,0,0,3.524,3.611A3.575,3.575,0,0,0-3.582,6.677",
    transform: "translate(14.504 0.459)",
    fill: "#076d38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(188.625 -42.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-3.3,0-6.417,7.864-9.621,0h-4.194l5.388,12.32-3.233,7.951h4.078L.806,0Z",
    transform: "translate(13.815)",
    fill: "#076d38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.993dcf0c05f89228f5fed6e3f6c482a3.svg";
export { ForwardRef as ReactComponent };